'use client';

import React from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { ReduxInitializer } from '@/app/ReduxInitializer';
import { ParcelSizeType } from '@/lib/type/type';
import Script from 'next/script';
import dynamic from 'next/dynamic';

const Footer = dynamic(
    () => import('@/components/layout/Footer/Footer').then((mod) => mod.Footer),
    { ssr: false },
);

interface ClientLayoutProps {
    children: React.ReactNode;
    packagingOptions: ParcelSizeType[];
}

export default function ClientLayout({ children, packagingOptions }: ClientLayoutProps) {
    return (
        <>
            <Provider store={store}>
                <Script
                    src="https://cdn.jsdelivr.net/npm/@cdek-it/widget@3"
                    strategy="beforeInteractive"
                    onLoad={() => console.log('CDEK Widget 3.0 JS loaded globally.')}
                    onError={(e) => console.error('Error loading CDEK Widget 3.0 JS:', e)}
                />

                <ReduxInitializer packagingOptions={packagingOptions} />

                {children}
                <Footer />
            </Provider>
        </>
    );
}
